export const ORDER_STATUSES = {
  CONFIRMATION_WAITING: 'confirmation_waiting',
  CONFIRMED: 'confirmed',
  READY: 'ready',
  COMPLETED: 'completed',
  REFUSE: 'refuse',
  CANCELLED: 'cancelled',
  FAILED: 'failed',
};

export const ORDER_STATUS_LABELS = {
  [ORDER_STATUSES.CONFIRMATION_WAITING]: 'confirmation_waiting',
  [ORDER_STATUSES.CONFIRMED]: 'confirmed',
  [ORDER_STATUSES.READY]: 'ready',
  [ORDER_STATUSES.COMPLETED]: 'completed',
  [ORDER_STATUSES.REFUSE]: 'refuse',
  [ORDER_STATUSES.CANCELLED]: 'cancelled',
  [ORDER_STATUSES.FAILED]: 'failed',
};

export const ORDER_STATUS = Object.values(ORDER_STATUSES);

/**
 * Тип предоплаты
 */
export const PREPAY_TYPES = {
  /** Без предоплаты */
  NONE: 'none',
  /** частичная предоплата */
  PARTIAL: 'partial',
  /** полная предоплата */
  FULL: 'full',
};

/**
 * Метод предоплаты
 */
export const PREPAY_METHODS = {
  /** Банковская карта */
  CARD: 'card',
  /** Банковский перевод по выставленному счету */
  INVOICE: 'invoice',
  /** Платежный агрегатор "OkPay" */
  OKPAY: 'okpay',
  /** Система SOFORT Banking */
  SOFORT: 'sofort',
  /** Оплата по договору взаиморасчетов с юр. лицами */
  CONTRACT: 'contract',
  /** Оплата с баланса */
  BALANCE: 'balance',
};

export const BALANCE_STATUS = [
  'pending',
  'declined',
  'completed',
  'paid',
];

export const BALANCE_TYPE = [
  'top_up_balance',
  'compensation',
  'correction',
  'refund',
  'withdrawals_additional_services',
  'withdrawals_penalty',
  'accrual_reward',
  'payout',
  'accrual_bonus',
];

export const EXTRA_PAYMENT_STATUS = [
  'pending',
  'canceled',
  'failed',
  'paid',
];

export const COUNTS = [
  {
    value: 25,
    name: 25,
  },
  {
    value: 50,
    name: 50,
  },
  {
    value: 75,
    name: 75,
  },
];

/**
 * @see src/assets/stylesheet/variables/_breakpoints.scss
 */
export const VIEW_SIZE_CODES = {
  XS: 'xs',
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
};

export const VIEW_SIZE_CONFIG = {
  [VIEW_SIZE_CODES.XS]: 0,
  [VIEW_SIZE_CODES.SM]: 576,
  [VIEW_SIZE_CODES.MD]: 928,
  [VIEW_SIZE_CODES.LG]: 992,
  [VIEW_SIZE_CODES.XL]: 1200,
};

export const DEFAULT_LOCALE = 'ru';
/**
 * Доп время, которое добавляется к MinEditableDate
 * для того, чтобы был запас на редактирование.
 * Без него можно перенести время старта за 1 мин до
 * запрета редактирования заказа
 */
export const ADDITIONAL_EDITABLE_TIME_DELAY = 5;

export const LOCATION_CODES = {
  /** Город */
  CTY: 'CTY',
  /** Аэропорт */
  AIR: 'AIR',
  /** Железнодорожный Вокзал */
  TRN: 'TRN',
  /** Порт */
  PRT: 'PRT',
  /** Автовокзал */
  BUS: 'BUS',
  /** Остров */
  ISL: 'ISL',
  /** Достопримечательности */
  POI: 'POI',
  /** Район */
  DST: 'DST',
  /** Пирс */
  PIR: 'PIR',
};

export const LOCATION_I18N_KEYS = {
  [LOCATION_CODES.AIR]: 'flight_number_info_cc',
  [LOCATION_CODES.BUS]: 'bus_number_info_cc',
  [LOCATION_CODES.TRN]: 'train_number_info_cc',
  [LOCATION_CODES.PRT]: 'ship_name_info_cc',
};

export const LOCATION_I18N_FULL_KEYS = {
  [LOCATION_CODES.AIR]: {
    label: 'board-number___point-type:airport',
    label2: 'transfer-start-date-and-time___point-type:airport',
    placeholder: 'board-number__placeholder___point-type:airport',
  },
  [LOCATION_CODES.BUS]: {
    label: 'board-number___point-type:bus-station',
    label2: 'transfer-start-date-and-time',
    placeholder: 'board-number__placeholder___point-type:bus-station',
  },
  [LOCATION_CODES.TRN]: {
    label: 'board-number___point-type:train-station',
    label2: 'transfer-start-date-and-time',
    placeholder: 'board-number__placeholder___point-type:train-station',
  },
  [LOCATION_CODES.PRT]: {
    label: 'board-number___point-type:port',
    label2: 'transfer-start-date-and-time___point-type:city',
    placeholder: 'board-number__placeholder___point-type:port',
  },
};

export const ADDITIONAL_SERVICES_CODES = {
  /**
   * Бустер
   */
  BSTR: 'BSTR',
  /**
   * Детское кресло (класс 2)
   */
  CHR: 'CHR',
  /**
   * Автомобильная люлька
   */
  CRDL: 'CRDL',
  /**
   * Питьевая вода
   */
  DW: 'DW',
  /**
   * Дополнительное время ожидания
   */
  EWT: 'EWT',
  /**
   * Заезд по пути
   */
  EXSTP: 'EXSTP',
  /**
   * Русскоговорящий водитель
   */
  LNGRU: 'LNGRU',
  /**
   * Англоговорящий водитель
   */
  LNGEN: 'LNGEN',
  /**
   * SIM карта
   */
  SIM: 'SIM',
  /**
   * ОТА: Услуга бесплатной отмены: low
   */
  INSR1: 'INSR1',
  /**
   * ОТА: Услуга бесплатной отмены: middle
   */
  INSR2: 'INSR2',
  /**
   * ОТА: Услуга бесплатной отмены: high
   */
  INSR3: 'INSR3',
  /**
   * ОТА: Услуга бесплатной отмены: highest
   */
  INSR4: 'INSR4',
  /**
   * Бокс для снаряжения
   */
  SKI_BOX_COUNT: 'SKIBOX',
  /**
   * Провоз снаряжения
   */
  SKI_EQUIPMENT_COUNT: 'SKI',
  /**
   * Организованная перевозка детей
   */
  CHILDTRN: 'CHILDTRN',
  /**
   * Со мной едут питомцы
   */
  PETS: 'PETS',
  /**
   * Транспортировка инвалидной коляски
   */
  WHEELCHR: 'WHEELCHR',
  /**
   * Женщина-водитель
   */
  WDRVW: 'WDRVW',
};

export const ADDITIONAL_SERVICES_I18N_KEYS = {
  [ADDITIONAL_SERVICES_CODES.BSTR]: 'number_child_seats_name_summary',
  [ADDITIONAL_SERVICES_CODES.CHR]: 'number_child_seats_name_summary',
  [ADDITIONAL_SERVICES_CODES.CRDL]: 'number_child_seats_name_summary',
  [ADDITIONAL_SERVICES_CODES.DW]: 'additional_services_water',
  [ADDITIONAL_SERVICES_CODES.EWT]: 'additional_services_time_summary',
  [ADDITIONAL_SERVICES_CODES.EXSTP]: 'additional_services_detour_summary',
  [ADDITIONAL_SERVICES_CODES.LNGRU]: 'additional_services_ru_driver_summary',
  [ADDITIONAL_SERVICES_CODES.LNGEN]: 'additional_services_en_driver_summary',
  [ADDITIONAL_SERVICES_CODES.SIM]: 'sim_cards_summary',
  [ADDITIONAL_SERVICES_CODES.INSR1]: 'free_cancel_insurance_summary',
  [ADDITIONAL_SERVICES_CODES.SKI_BOX_COUNT]: 'additional_services_box_ski_equipment_summary',
  [ADDITIONAL_SERVICES_CODES.SKI_EQUIPMENT_COUNT]: 'additional_services_carry_ski_equipment_summary',
  [ADDITIONAL_SERVICES_CODES.CHILDTRN]: 'additional_services_childtrn_summary',
  [ADDITIONAL_SERVICES_CODES.PETS]: 'additional_services_pets_summary',
  [ADDITIONAL_SERVICES_CODES.WHEELCHR]: 'additional_services_wheelchr_summary',
  [ADDITIONAL_SERVICES_CODES.WDRVW]: 'additional_services_wdrvw_summary',
};

export const ADDITIONAL_SERVICES_SEAT_CODES = {
  /** Booster */
  [ADDITIONAL_SERVICES_CODES.BSTR]: 'baby-booster',
  /** Seat */
  [ADDITIONAL_SERVICES_CODES.CHR]: 'baby-seat',
  /** Infant seat */
  [ADDITIONAL_SERVICES_CODES.CRDL]: 'baby-cradle',
};

/**
 * Порядок вывода кресел
 */
export const ADDITIONAL_SERVICES_SEAT_ORDER = {
  [ADDITIONAL_SERVICES_CODES.CRDL]: 1,
  [ADDITIONAL_SERVICES_CODES.CHR]: 2,
  [ADDITIONAL_SERVICES_CODES.BSTR]: 3,
};

export const ADDITIONAL_SERVICES_SEAT_WEIGHT_CODES = {
  /** Booster */
  [ADDITIONAL_SERVICES_CODES.BSTR]: 'baby-booster-weight',
  /** Seat */
  [ADDITIONAL_SERVICES_CODES.CHR]: 'baby-seat-weight',
  /** Infant seat */
  [ADDITIONAL_SERVICES_CODES.CRDL]: 'baby-cradle-weight',
};

/**
 * Classes Of vehicle
 */

export const VEHICLE_CLASS_CODES = {
  ECN: 'ECN',
  CMT: 'CMT',
  MB7: 'MB7',
  MV4: 'MV4',
  PRM: 'PRM',
  MB13: 'MB13',
  MB16: 'MB16',
  MB19: 'MB19',
  SH: 'SH',
  MCR: 'MCR',
  PM6: 'PM6',
  MB10: 'MB10',
  BSN: 'BSN',
  SUV: 'SUV',
  LSUV: 'LSUV',
};

export const isSLA1 = (code) => [
  VEHICLE_CLASS_CODES.MCR,
  VEHICLE_CLASS_CODES.ECN,
  VEHICLE_CLASS_CODES.CMT,
  VEHICLE_CLASS_CODES.MV4,
  VEHICLE_CLASS_CODES.MB7,
  VEHICLE_CLASS_CODES.SUV,
].includes(code);

export const VEHICLE_CLASS_I18N = {
  name: code => `name__transfer-type:${code}`,
  about: code => `about__transfer-type:${code}`,
  models: code => `car-models__transfer-type:${code}`,
};

export const SEARCH_ALGORITHMS = {
  /**
   * Поиск фразы в названии маршрутной точки
   */
  FULLTEXT: 'fulltext',
  /**
   * Поиск маршрутной точки на основе картографических эвристик
   */
  GEO: 'geo',
};

export const LANGUAGES = [
  {
    name: 'Русский',
    value: 'ru',
  },
  {
    name: 'English',
    value: 'en',
  },
];



// WEBPACK FOOTER //
// ./src/utils/Constants.js